export const SET_RAW_RESULTS = 'SET_RAW_RESULTS';
export const SET_SINGLE_RESULTS = 'SET_SINGLE_RESULTS';
export const SET_RESULTS_IN_COLUMN = 'SET_RESULTS_IN_COLUMN';
export const SET_THRESHOLDS = 'SET_THRESHOLDS';
export const SET_PERCENTAGE_VOTES = 'SET_PERCENTAGE_VOTES';
export const SET_YEAR = 'SET_YEAR';
export const CREATE_COALITION = 'CREATE_COALITION';
export const SET_METHOD = 'SET_METHOD';
